export const apiSettings = {
    user_ver: 'v1',
    event_ver: 'v1',
    styles_ver:'v1',
    subscribe_ver:'v1',
    files_ver:'v1',
    payment_ver:'v1'
};
